import { 
    apiBizGetOrganizationGroupList,
    apiBizGetOrganizationGroupInfo,
    apiBizInsertOrganizationGroup,
    apiBizDelOrganizationGroup,
    apiBizEditOrganizationGroup,
    } from "@/apis/api.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_organization_group_list: 'internalAuth/organizationGroup/set_organization_group_list',
    set_organization_group_info: 'internalAuth/organizationGroup/set_organization_group_info',
    set_organization_filter_word: 'internalAuth/organizationGroup/set_organization_filter_word',
}

// count state 必須是 Object
const state = {
    organizationGroupList: [],
    organizationGroupInfo: [],
    filter: {
        word: null,
        options: {

        }
    }
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_ORGANIZATION_GROUP_LIST: (state) => {
        return state.organizationGroupList
    },
    GET_BIZ_ORGANIZATION_GROUP_INFO: (state) => {
        return state.organizationGroupInfo
    },
    GET_BIZ_ORGANIZATION_FILTER_WORD: (state) => {
        return state.filter.word
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    //  取得業務分群列表
    getBizOrganizationGroupList ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            apiBizGetOrganizationGroupList()
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    if( res.data.result.length > 0){
                        commit(types.set_organization_group_list, res.data.result);
                        resolve()
                    }
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    // 取得單一業務分群
    getBizOrganizationGroupInfo ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            apiBizGetOrganizationGroupInfo(value)
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_organization_group_info, res.data.result);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    // 新增業務分群
    insertBizOrganizationGroup ( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            apiBizInsertOrganizationGroup(data)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    // 編輯業務分群
    editBizOrganizationGroup ( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            apiBizEditOrganizationGroup(data)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    // 刪除業務分群
    delBizOrganizationGroup ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            apiBizDelOrganizationGroup(value)
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    resolve(res)
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    // 設定搜尋文字
    setlBizOrganizationFilterWord ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_account_filter_word, value);
            
        })
    },
    
}

// mutations
const mutations = {
    [types.set_organization_group_list](state, data){
        state.organizationGroupList = data
    },
    [types.set_organization_group_info](state, data){
        state.organizationGroupInfo = data
    },
    [types.set_organization_filter_word](state, data){
        state.filter.word = data
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/internalAuth/organizationGroup/organizationGroup.js